<template>
  <img :src="realSrc" :alt="alt" />
</template>
 
<script setup>
import { computed, defineProps } from 'vue'
 
const props = defineProps({
  src: String,
  name: String,
  alt: String
})

const realSrc = computed(() => {
  if (props.src) {
    return props.src
  }
  if (props.name) {
    const suffix = props.name.indexOf('.png') !== -1 ? '' : '.svg'
    return require(`../assets/icons/${props.name}${suffix}`);
  }
  return ''
})
</script>
 
<style scoped>
img {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
}
</style>